import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ReadMoreText from "./ReadMoreText";

import "swiper/css";
import "swiper/css/pagination";

function Testimonial() {
  const [isSlider, setIsSlider] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSlider(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const testimonials = [
    {
      name: "Rahul Mehta",
      role: "Founder, GrowthStack",
      text: "The quality of data we received from Datroniq was unlike anything we'd seen. Our conversion rates jumped significantly within the first month.",
      avatar: "R",
    },
    {
      name: "Priya Singh",
      role: "Head of Sales, FinBridge",
      text: "We needed hyper-specific B2B data for a niche market. Datroniq delivered exactly what we asked for.",
      avatar: "P",
    },
    {
      name: "Ankit Verma",
      role: "CTO, RetailEdge",
      text: "Finally a data partner that understands compliance. Fast delivery and highly reliable datasets.",
      avatar: "A",
    },
  ];

  return (
    <section className="testimonials-section">
      <div className="container">

        {/* Header */}
        <div className="testimonials-header">
          <span className="section-label">WHAT CLIENTS SAY</span>
          <h2 className="section-title">
            Trusted by Businesses Across India
          </h2>
        </div>

        {/* 🔁 CONDITION */}
        {isSlider ? (

          /* 🔥 SLIDER (Mobile + Laptop) */
          <Swiper
			  modules={[Pagination, Autoplay]}
			  spaceBetween={20}
			  centeredSlides={true}
			  loop={true}
			  autoplay={{ delay: 3000 }}
			  pagination={{ clickable: true }}
			  breakpoints={{
				0: { slidesPerView: 1 },     // ✅ FIX: mobile ke liye 1 rakho
				480: { slidesPerView: 1.2 },
				768: { slidesPerView: 2 },
			  }}
			>
            {testimonials.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="testimonial-card slider-card">
                  <div className="stars">★★★★★</div>
				  <ReadMoreText text={item.text} />

                  <div className="t-author">
                    <div className="t-avatar">{item.avatar}</div>
                    <div>
                      <div className="t-name">{item.name}</div>
                      <div className="t-role">{item.role}</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        ) : (

          /* 🖥 DESKTOP GRID */
          <div className="testimonial-grid">
            {testimonials.map((item, i) => (
              <div className="testimonial-card" key={i}>
                <div className="stars">★★★★★</div>
                <p>"{item.text}"</p>

                <div className="t-author">
                  <div className="t-avatar">{item.avatar}</div>
                  <div>
                    <div className="t-name">{item.name}</div>
                    <div className="t-role">{item.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        )}

      </div>
    </section>
  );
}

export default Testimonial;